export const version = '2.21.32';
//# sourceMappingURL=version.js.map